module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"previous":"Go back","next":"Continue"}}')
  delete Component.options._Ctor
}
